import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: { isPending: false, isSuccessful: false, isFailure: false },
};

function handleRequest(): State {
  return { request: { ...initialState.request, isPending: true } };
}

function handleSuccess(): State {
  return { request: { ...initialState.request, isSuccessful: true } };
}

function handleFailure(): State {
  return { request: { ...initialState.request, isFailure: true } };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.updateOrganizationalUnitRequested]: handleRequest,
    [events.updateOrganizationalUnitSucceeded]: handleSuccess,
    [events.updateOrganizationalUnitFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
